import React from 'react';
import { Box, Container, Typography, Grid, Paper, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Assets
import d247Logo from "../assets/d247logo.png";
import al777 from "../assets/al777.png";
import casino from "../assets/casino.png";
import board from "../assets/board.png";
import cricket from "../assets/cricket.png";
import football from "../assets/football.png";
// import MadrasBook from "../assets/MadrasBook.png";
// import AmiriBook from "../assets/AmiriBook.png";
// import VictorOnlineBook from "../assets/VictorOnlineBook.png";
// import VintageOnlineBook from "../assets/VintageOnlineBook.png";
import my99exch from "../assets/my99exch.png";
import AllPanelExch from "../assets/AllPanelExch.png";
import Powerwin from "../assets/Powerwin.png";
import Laser247 from "../assets/Laser247.png";
import TigerExchange from "../assets/TigerExchange.png";
import hourse_racing from "../assets/hourse-racing.png";
import greyhandracing from "../assets/greyhandracing.png";
import kabaddi from "../assets/kabaddi.png";
import voting_box from "../assets/voting-box.png";
import Binary from "../assets/Binary.png";
import Ram247 from "../assets/Ram247.png";
import dreamexch from "../assets/dreamexch.png";


const sites = [
    { img: d247Logo, url: "https://www.d247.com/" }, // Keeping D247 as existing asset
    { img: al777, url: "https://allpanel777.now/" }, // Keeping Al777 as existing asset
    // { img: MadrasBook, url: "https://madrasbook.in/" },
    // { img: AmiriBook, url: "https://amiribook.com/" },
    // { img: VictorOnlineBook, url: "https://victoronlinebook247.com/" },
    // { img: VintageOnlineBook, url: "https://vintageonlinebook.com/" },
    { img: my99exch, url: "https://my99exch.tech/" },
    { img: AllPanelExch, url: "http://www.allpanelexch.app/" },
    { img: Powerwin, url: "https://powerwin.green/" },
    { img: Laser247, url: "https://mylaser247.info/" },
    { img: TigerExchange, url: "https://mytiger247.pro/" },
    { img: Ram247, url: "https://ram247.net/" },
    { img: dreamexch, url: "https://dreamexch24.com/" }
];

const games = [
    { img: cricket, title: 'Cricket 🏏' },
    { img: football, title: 'Football ⚽️' },
    { img: board, title: 'Tennis 🎾' }, // Reusing board image for now or finding a better match if possible, but title is priority
    //   { img: casino, title: 'Live Casino' },
    { img: hourse_racing, title: 'Horse Racing' },
    { img: greyhandracing, title: 'GreyHound Racing' },
    { img: kabaddi, title: 'Kabaddi' },
    { img: voting_box, title: 'Election' },
    { img: Binary, title: 'Binary' },
];

const SiteCard = ({ img, url }) => {
    const theme = useTheme();
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <Paper
                component="a"
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                elevation={4}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '120px',
                    width: '100%',
                    p: 2,
                    background: 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(5px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    borderRadius: '15px',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    position: 'relative',
                    '&:hover': {
                        border: `1px solid ${theme.palette.secondary.main}`,
                        boxShadow: `0 0 20px rgba(255, 217, 0, 0.1)`,
                        transform: 'translateY(-5px)',
                        background: 'rgba(255, 255, 255, 0.1)',
                    }
                }}
            >
                <Box
                    component="img"
                    src={img}
                    alt="Site Logo"
                    sx={{
                        maxWidth: '80%',
                        maxHeight: '70px',
                        objectFit: 'contain',
                        filter: 'grayscale(0%)', // Keep original colors as logos are important
                        transition: 'transform 0.3s',
                        '&:hover': {
                            transform: 'scale(1.1)'
                        }
                    }}
                />
            </Paper>
            <Button
                variant="contained"
                size="small"
                href={url}
                target="_blank"
                sx={{
                    mt: 2,
                    background: theme.palette.secondary.main,
                    color: '#000',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    borderRadius: '20px',
                    px: 3,
                    boxShadow: `0 0 10px ${theme.palette.secondary.main}`,
                    '&:hover': {
                        background: '#ece7e7ff',
                        transform: 'scale(1.05)',
                        boxShadow: `0 0 20px #ece7e7ff`
                    }
                }}
            >
                Demo �
            </Button>
        </Box>
    );
};

const GameCard = ({ img, title }) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                textAlign: 'center',
                transition: 'transform 0.3s',
                '&:hover': { transform: 'scale(1.05)' }
            }}
        >
            <Box
                sx={{
                    width: '150px',
                    height: '150px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    mb: 2,
                    mx: 'auto',
                    border: `3px solid ${theme.palette.primary.main}`,
                    boxShadow: `0 0 20px rgba(139, 0, 0, 0.5)`,
                    position: 'relative'
                }}
            >
                <Box
                    component="img"
                    src={img}
                    alt={title}
                    sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </Box>
            <Typography variant="h6" sx={{ color: theme.palette.secondary.main, fontWeight: 600 }}>
                {title}
            </Typography>
        </Box>
    );
};

const SitesSection = () => {
    const theme = useTheme();

    return (
        <Box sx={{ py: 10, background: 'linear-gradient(to bottom, #000000, #110000)' }}>
            <Container maxWidth="xl">

                {/* Sites Subsection */}
                <Box sx={{ mb: 10 }}>
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        sx={{
                            color: '#fff',
                            mb: 1,
                            fontWeight: 700
                        }}
                    >
                        PREMIUM <span style={{ color: theme.palette.primary.main }}>PARTNERS</span>
                    </Typography>
                    <Typography variant="subtitle1" align="center" sx={{ color: 'gray', mb: 6 }}>
                        Trusted platforms for high-stakes gaming
                    </Typography>

                    <Grid container spacing={4} justifyContent="center">
                        {sites.map((site, index) => (
                            <Grid item xs={6} sm={6} md={3} key={index}>
                                <SiteCard img={site.img} url={site.url} />
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                {/* Games Subsection */}
                <Box>
                    <Typography
                        variant="h3"
                        align="center"
                        gutterBottom
                        sx={{
                            color: '#fff',
                            mb: 1,
                            fontWeight: 700
                        }}
                    >
                        TOP <span style={{ color: theme.palette.secondary.main }}>GAMES</span>
                    </Typography>
                    <Typography variant="subtitle1" align="center" sx={{ color: 'gray', mb: 8 }}>
                        Experience the thrill of victory
                    </Typography>

                    <Grid container spacing={4} justifyContent="center">
                        {games.map((game, index) => (
                            <Grid item xs={6} md={3} key={index}>
                                <GameCard img={game.img} title={game.title} />
                            </Grid>
                        ))}
                    </Grid>

                    <Box sx={{ textAlign: 'center', mt: 8 }}>
                        <Button
                            variant="outlined"
                            endIcon={<ArrowForwardIcon />}
                            sx={{
                                color: theme.palette.secondary.main,
                                borderColor: theme.palette.secondary.main,
                                fontSize: '1.2rem',
                                px: 4,
                                '&:hover': {
                                    borderColor: '#fff',
                                    color: '#fff',
                                    background: 'rgba(255,215,0,0.1)'
                                }
                            }}
                            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} // Or open contact
                        >
                            Start Playing Now
                        </Button>
                    </Box>
                </Box>

            </Container>
        </Box>
    );
};

export default SitesSection;
